module.exports = __webpack_public_path__ + "img/nav-bg.e9d6249c.jpg";